import { FormField, Label } from "semantic-ui-react";
import { colors } from "../../style";
import { Icon } from "./Icon";
import { ui } from "./styles";

export function Checkbox({ checked, onChange, children }) {
  return (
    <label
      className="sk-row"
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "9px 10px",
        borderRadius: "9px",
        fontSize: "14px",
        cursor: "pointer",
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        style={{ position: "absolute", opacity: 0, width: 0, height: 0 }}
      />
      <span
        className="sk-box"
        style={{
          flex: "none",
          width: "18px",
          height: "18px",
          boxSizing: "border-box",
          borderRadius: "5px",
          border: `1.5px solid ${checked ? colors.teal : colors.textFaint}`,
          background: checked ? colors.teal : "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {checked && <Icon name="check" size={12} color={colors.onPrimary} />}
      </span>
      <span style={{ flex: 1, minWidth: 0 }}>{children}</span>
    </label>
  );
}

// Label above a control, like the desktop app's forms. Not a wrapping
// <label>: that re-dispatches clicks and toggles Semantic dropdowns twice.
// variant="form": a Semantic Form.Field (label, hint, red Label error, then
// the control), for fields inside a Semantic <Form>.
export function Field({
  label,
  htmlFor,
  hint,
  error,
  variant = "stack",
  children,
  style,
}) {
  if (variant === "form") {
    return (
      <FormField style={style}>
        {label && <label htmlFor={htmlFor}>{label}</label>}
        {hint && (
          <div style={{ marginBottom: "8px" }}>
            <small>{hint}</small>
          </div>
        )}
        {error && <Label color="red">{error}</Label>}
        {children}
      </FormField>
    );
  }
  return (
    <div style={{ ...ui.field, ...style }}>
      {label && (htmlFor ? <label htmlFor={htmlFor}>{label}</label> : label)}
      {children}
      {hint && !error && (
        <span style={{ ...ui.muted, fontWeight: 400 }}>{hint}</span>
      )}
      {error && <span style={{ ...ui.error, fontSize: "12px" }}>{error}</span>}
    </div>
  );
}

// Plain styled <input> for forms that aren't Semantic. Extra props go to it.
export function TextInput({ invalid, style, ...props }) {
  return (
    <input
      aria-invalid={invalid || undefined}
      {...props}
      style={{
        ...ui.input,
        ...(invalid ? { borderColor: colors.red } : null),
        ...style,
      }}
    />
  );
}

// Extra props go to the <input>
export function SearchField({
  value,
  onChange,
  label,
  placeholder,
  style,
  ...props
}) {
  return (
    <label style={{ ...ui.searchBox, ...style }}>
      <Icon name="search" size={16} color={colors.textMuted} />
      <input
        type="search"
        aria-label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...props}
        style={{
          flex: 1,
          minWidth: 0,
          border: 0,
          background: "none",
          color: colors.text,
          fontFamily: "inherit",
          fontSize: "14px",
          outline: "none",
        }}
      />
    </label>
  );
}
